module.exports = __webpack_public_path__ + "static/img/p8.fef6c27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p8.png
// module id = z79M
// module chunks = 0